import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const PresentationChart = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g>
        <g>
          <path
            d="M5.90024 17.4077H18.0902C19.9902 17.4077 20.9902 16.4077 20.9902 14.5077V2.40771H2.99023V14.5077C3.00023 16.4077 4.00024 17.4077 5.90024 17.4077Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2 2.40771H22"
            stroke={stroke}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 22.4077L12 20.4077V17.4077"
            stroke={stroke}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16 22.4077L12 20.4077"
            stroke={stroke}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.5 11.4077L10.65 8.77771C10.9 8.56771 11.23 8.62771 11.4 8.90771L12.6 10.9077C12.77 11.1877 13.1 11.2377 13.35 11.0377L16.5 8.40771"
            stroke={stroke}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

PresentationChart.displayName = 'PresentationChart';
